import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import address from './address';
import app from './app';
import comparables from './comparables';
import filter from './filter';
import marketing from './marketing';
import { marketTrends, unfilteredMarketTrends } from './marketTrends';
import { medianRentByBedroom } from './medianRentByBedroom';
import search from './search';
import topMarkets from './topMarkets';
import ui from './ui';
import user from './user';

const rootReducer = (history) =>
  combineReducers({
    app,
    address,
    comparables,
    filter,
    marketing,
    marketTrends,
    medianRentByBedroom,
    search,
    topMarkets,
    ui,
    unfilteredMarketTrends,
    user,
    router: connectRouter(history),
  });

export default rootReducer;
